'use strict'

appUrl = require '../../page/frontend/helpers/app_url'
urlUpdate = require '../../page/frontend/helpers/url_update'
CardsView = require './views/cards'
errorViewHtml = require './views/error_html'
locationRemembrance = require './location_remembrance'
CarouselScrollRemembrance = require './carousel_scroll_remembrance'
PaginationFooter = require '../../pagination/frontend/views/footer'
PaginationSeoLinks = require '../../pagination/frontend/helpers/seo_links'
PageHeaderView = require '../../page_header/frontend/views/header'
RapiDebugView = require './views/rapi_debug'
spinnerGroup = require '../../page/frontend/helpers/spinner_group'
ViewNoCards = require './views/no_cards'
domConfig = require '../../page/frontend/helpers/dom_config'
WidgetRetriever = require './model/widget'
WidgetView = require '../../page/frontend/views/bottom_widget'
ScrollDepthView = require './views/scroll_depth'
AdsenseAdsView = require '../../adsense_ads/frontend/views/adsense_ads'
{checkSetting, isFeatureEnabled, isInTreatment} = require '../../page/frontend/helpers/finch'
isTTDLandingPage = require '../../page/frontend/helpers/is_ttd_landing_page'
{ isEmpty, omitUndefined } = require '../../page/helpers/underscore_replacement'
facetsRetriever = require './model/facets'
relatedRetriever = require './model/related'
SearchRetriever = require './model/search'
{ windowLoaded, documentReady} = require '@grpn/document-states'
{ toString } = require '../../page/frontend/helpers/params'
{ addMouseDownListenerForCard } = require '../../page/frontend/helpers/event_listener'
debounce = require '../../page/frontend/helpers/debounce'
shallowEqualObjects = require '../../page/frontend/helpers/shallow_equal_objects'
shallowLooseEqualObjects = require '../../page/frontend/helpers/shallow_loose_equal_objects'
{ setShellEventOrRun } = require('@grpn/shell-page')

SELECTORS =
  CARDS_WRAPPER: '#pull-results'
  CARDS: '#pull-cards'
  PAGINATION: '#pull-pagination'
  NOCARDS: '#pull-no-cards'
  CARDSERROR: '#pull-oops-error'
  DEBUG: '#RapiDebugData'
  NOCARDS_MESSAGE_GETAWAYS: '.getaways_notification'
  REFINEMENT_UI: '#refinement-ui'
  FEATURED_FILTER_TOOLTIPS: '.featured-filter-tooltip'
  FEATURED_REFINEMENT_UI: '#featured-refinement-ui'
  FEATURED_RIGHT_END_REFINEMENT_UI: '#featured-right-end-refinement-ui'
  PAGE_HEADER_TITLE: '#pull-page-header-title'
  CARD_IMAGES: '.cui-c-udc .cui-image'
  FEATURED_CARDS: '.cui-c-udc-featured'
  FALLBACK_FEATURED_CARDS: '.cui-c-udc-featured-fallback'
  EMBEDDED_CARDS: '.cui-is-embedded-card'
  WIDGET_VIEW_CONTAINER: '#pull-widget-container'
  WIDGET_VIEW: '#pull-widget'
  ADSENSE_ADS_VIEW: '#pull-ads'
  TWO_COLUMN: 'two'
  THREE_COLUMN: 'three'
  NINE_COLUMN: 'nine'
  TEN_COLUMN: 'ten'

STICKY =
  HEADER: '#sticky-header'
  REFINEMENT: '#sticky-refinements'

context = module.exports =
  defaults:
    urlParams: {}
    xhrParams: {}
    spinnerRunning: false

  initialize: ->
    setShellEventOrRun(=>
      @domConfig = domConfig.get() ? {}
      documentReady.then( => @onReady())
      windowLoaded.then( => @onLoad())
    )

  onLoad: ->
    @_setDefaults()
    window.Groupon.Utils.loadAsyncJS(@domConfig.browseLazyLoadedCardUiJavascript, @_onLazyLoadedCardUiJavascript)
    window.Groupon.Utils.loadAsyncJS(@domConfig.browseLazyLoadedFiltersUiJavascript, @_onLazyLoadedFiltersUiJavascript)
    window.Groupon.Utils.loadAsyncJS(@domConfig.browseLazyLoadedThingsToDoJavascript, @_onLazyLoadedThingsToDoJavascript) if @domConfig.enabledFeatures?.isTTDPage
    @_createModelsAndViews()
    @_handlePageState()
    @_addListeners()
    @_lazyLoadRemainingDeals() unless @hasLoadedDealsWithLocationRememberance
    @_loadAds()

  onReady: ->
    PaginationSeoLinks.set()

  _onLazyLoadedCardUiJavascript: ->
    window.CardUI.init()
    window.GIG.Modal.init()
    document.body.classList.add 'pull-app-card-ui-js-lazy-loaded'

  _onLazyLoadedFiltersUiJavascript: ->
    context._initFiltersUi()

  _onLazyLoadedMapsJavascript: ->
    window.BrowseMapsApplication.initialize()
    window.BrowseMapsApplication.loadMap()
    document.body.classList.add 'pull-app-maps-js-lazy-loaded'

  _onLazyLoadedThingsToDoJavascript: ->
    window.BrowseThingsToDoApplication?.fetchTargetedAudience() if isTTDLandingPage()
    document.body.classList.add 'pull-app-things-to-do-js-lazy-loaded'

  _loadAds: ->
    return unless @domConfig.enabledFeatures?.showLivingSocialAfsAds && @urlParams.query?
    currentPage = if @urlParams.page? then parseInt(@urlParams.page) else 1

    @adsenseAdsView.loadAds(@urlParams.query, currentPage)

  _lazyLoadRemainingDeals: ->
    return unless @lazyLoadingRetriever
    numOfshellCards = document.querySelectorAll("#{SELECTORS.CARDS} .cui-shell-card").length
    return unless numOfshellCards

    if @domConfig.appliedFinchSettings?.includes('proactiveCachedAllDealsPage:true')
      @_removeShellCards()
    else
      lazyLoadingOffset = document.querySelectorAll(
        "#{SELECTORS.CARDS} .card-ui" +
        ":not(.cui-shell-card)" +
        ":not(.cui-c-udc-featured-fallback)" +
        ":not(.cui-c-band)"
      ).length
      @lazyLoadingRetriever.get(Object.assign {}, @xhrParams, { lazyLoadingOffset }).then(
        (res) => @_onLazyLoadingModelSync res
        (err) -> # TODO
      )

  _truncateElements: ->
    GIG.Utils.truncateElements()

  _setDefaults: ->
    baseParams = window.Groupon.Utils.unparam()

    @defaults.xhrParams = omitUndefined
      _csrf: @domConfig.csrfToken
      category: baseParams.category
      division: @domConfig.division?.id

    if baseParams?.category?
      @defaults.urlParams.category = baseParams.category

    @_setParams(baseParams)

    @shouldShowMapButton = @domConfig.map?.show

  _setParams: (params) ->
    @urlParams = Object.assign {}, @defaults.urlParams, params
    @xhrParams = Object.assign {}, @defaults.xhrParams, params
    @shouldRefreshRefinements = true

  _initFiltersUi: ->
    if window.FiltersUI && @domConfig.enabledFeatures?.refinementUI
      @_getRefinements()
      document.querySelector(SELECTORS.FEATURED_REFINEMENT_UI)?.classList.remove 'inactive-till-lazy-load'
      document.querySelector(SELECTORS.FEATURED_RIGHT_END_REFINEMENT_UI)?.classList.remove 'inactive-till-lazy-load'

  _initCardUI: ->
    if window.CardUI
      window.CardUI.init()

  _adjustFilterContainerWidth: (isMapVisible) ->
    leftFilters = document.querySelector(SELECTORS.FEATURED_REFINEMENT_UI)
    rightfilters = document.querySelector(SELECTORS.FEATURED_RIGHT_END_REFINEMENT_UI)

    if leftFilters? and rightfilters?
      if isMapVisible
        leftFilters.classList.remove(SELECTORS.TEN_COLUMN)
        leftFilters.classList.add(SELECTORS.NINE_COLUMN)
        rightfilters.classList.remove(SELECTORS.TWO_COLUMN)
        rightfilters.classList.add(SELECTORS.THREE_COLUMN)
      else
        leftFilters.classList.add(SELECTORS.TEN_COLUMN)
        leftFilters.classList.remove(SELECTORS.NINE_COLUMN)
        rightfilters.classList.add(SELECTORS.TWO_COLUMN)
        rightfilters.classList.remove(SELECTORS.THREE_COLUMN)

  _isNoResultsRefinements: (refinements = []) ->
    return refinements.every (refinement) ->
      noResultsRefinementIds = ['search', 'sort', 'map']
      noResultsRefinementIds.includes refinement.id

  _clearHtml: (element) ->
    while(element?.firstChild)
      element.removeChild(element.firstChild)

  _hideSkeletons: (refinements = []) ->
    @_clearHtml document.querySelector(SELECTORS.FEATURED_REFINEMENT_UI)
    @_clearHtml document.querySelector(SELECTORS.FEATURED_RIGHT_END_REFINEMENT_UI)

  _filtersLazyLoadComplete: ->
    document.body.classList.add 'pull-app-filters-ui-js-lazy-loaded'

  _loadRefinementUi: (refinements = []) ->
    if not refinements.length or @_isNoResultsRefinements(refinements)
      @_hideSkeletons()
      return
    return unless window.FiltersUI?
    return if @desktopFilters

    @desktopFilters = new window.FiltersUI()
    options = @_getFilterOptions()

    if @domConfig.enabledFeatures?.refinementUI
      if options.showLeftHandNav
        rightData = refinements.filter(
          (refinement) -> refinement.featuredPositionOverride
        )
        @desktopFilters.renderLeftHandNav(refinements, 'refinement-ui', options)
        @desktopFilters.renderFeaturedRight(rightData, 'pull-filter-row', options)
        @_attachMapButtonListener()
      else
        @desktopFilters.loadRefinements(refinements, options)
        featuredLeftData = refinements.filter(
          (refinement) -> !refinement.featuredPositionOverride
        )
        featuredRightData = refinements.filter(
          (refinement) -> refinement.featuredPositionOverride
        )

        @desktopFilters.renderFeatured(featuredLeftData, 'featured-refinement-ui', Object.assign({}, options, {showReset: true}))
        @desktopFilters.renderFeaturedRight(featuredRightData, 'featured-right-end-refinement-ui', options)
        @desktopFilters.renderBookingFilters(refinements, 'featured-booking-filters-refinement-ui', options)

        @_attachMapButtonListener()
        @_updateMapButton(options.showMapButton)
        @_filtersLazyLoadComplete()

    document.addEventListener 'refinementsUpdated', (event) =>
      @_clearNoCardsMessage()
      @_onUpdate(event.detail, true)

  _getRefinements: (attempts = 1) ->
    facetsRetriever.getFacets(@xhrParams).then(
      (data) =>
        @_loadRefinementUi(data.refinementUI?.widgets)
      (err) =>
        if attempts <= 1
          @_getRefinements(attempts + 1)
    )

  _createModelsAndViews: ->
    @searchRetriever = new SearchRetriever()
    @preloadedNextPageRetriever = new SearchRetriever()
    @lazyLoadingRetriever = new SearchRetriever() if @domConfig.enabledFeatures?.lazyLoadingBrowseSearchPages
    @cardsView = new CardsView el: SELECTORS.CARDS
    @noCardsView = new ViewNoCards el: SELECTORS.NOCARDS
    @paginationView = new PaginationFooter
      el: SELECTORS.PAGINATION
    @pageHeaderView = new PageHeaderView el: SELECTORS.PAGE_HEADER_TITLE
    @debugView = new RapiDebugView el: SELECTORS.DEBUG
    @adsenseAdsView = new AdsenseAdsView el: SELECTORS.ADSENSE_ADS_VIEW
    @scrollDepthView = new ScrollDepthView()

    @_setupBottomWidget() unless (@domConfig.enabledFeatures?.isTTDPage and checkSetting('showPlanAheadWidget'))
    @_setupLazyloadedDealsWithLocationRememberance()

  _setupLazyloadedDealsWithLocationRememberance: ->
    return unless @lazyLoadingRetriever
    return unless window.history.state
    {sanitizedCardsHtml, selectedDealBhc, selectedDealYOffset} = window.history.state
    return unless !!sanitizedCardsHtml and !sanitizedCardsHtml.includes('cui-shell-card')
    document.querySelector(SELECTORS.CARDS).innerHTML = sanitizedCardsHtml

    allCards = document.querySelectorAll(SELECTORS.CARDS + ' .card-ui:not(.has-location-rememberance-listener)')
    allCards.forEach(addMouseDownListenerForCard())
    deal = document.querySelector(".card-ui[data-bhc='" + selectedDealBhc + "']")
    if deal
      deal.scrollIntoView()
    else if selectedDealYOffset
      window.scrollTo({top: selectedDealYOffset})
    @_initCardUI()
    @hasLoadedDealsWithLocationRememberance = true

  _setupBottomWidget: ->
    @widgetRetriever = new WidgetRetriever()
    @bottomWidgetView = new WidgetView
      el: SELECTORS.WIDGET_VIEW
      retriever: @widgetRetriever
      afterRender: => @carouselScrollRemembrance.scrollCarouselToLastRememberedPosition()
      _csrf: @domConfig.csrfToken

  _hackCheckIfNextPageExists: ->
    document.querySelector('#pull-pagination')?.style.display != 'none' && document.querySelector('#pull-pagination a.next[href]') != null

  _addPreloadNextPageScrollListener: ->
    @_handlePreloadingDeals = =>
      if window.scrollY / document.body.scrollHeight > .35
        if @_hackCheckIfNextPageExists()
          @preloadedNextPageNum = if @xhrParams.page? then (Number.parseInt(@xhrParams.page) + 1).toString() else '2'
          @preloadedNextPageRetriever.get(Object.assign {}, @xhrParams, { page: @preloadedNextPageNum }).then(
            (res) => @_onPreloadedNextPageModelSync res
            (err) -> # TODO
          )
        window.removeEventListener('scroll', @_onScroll)

    @_onScroll = debounce(@_handlePreloadingDeals, 250)
    window.addEventListener('scroll', @_onScroll)

  _addRelatedCardOnMouseDownListeners: ->
    relatedCards = document.querySelectorAll("figure[data-bhd*='thingsToDo_related_deals_browse'] .cui-c-udc")
    relatedCards.forEach(addMouseDownListenerForCard()) if relatedCards.length

  _addListeners: ->
    if @_removeLHNEnabled()
      @_toggleStickyHeader()

    locationRemembrance.initialize('desktop:dealClickedId')
    @carouselScrollRemembrance = new CarouselScrollRemembrance('desktop:carouselDealClickedId')
    @carouselScrollRemembrance.addEventListener()

    @lastClickedDeal = locationRemembrance.getLastDealId()

    if @lastClickedDeal and @_canShowRelatedDeals()
      @_fetchRelated()

    if @preloadedNextPageRetriever
      @_addPreloadNextPageScrollListener()

    document.querySelector(SELECTORS.PAGINATION)?.addEventListener 'click:paginationLink', @_onPaginationClick()

    document.addEventListener 'refinementsUpdated', (event) =>
      @_clearNoCardsMessage()
      selectedRefinements = event.detail
      @_onUpdate(selectedRefinements, true)

    window.onpopstate = => @_onPopState()

  _attachMapButtonListener: ->
    @mapEl = document.querySelector('#pull-map')
    @mapButtonToggleEl = document.querySelector('.pull-map-button') or document.querySelector('#featured-map-box')
    if @mapButtonToggleEl
      @mapButtonToggleEl.addEventListener 'click', =>
        @_toggleMap()

  _toggleMap: ->
    if @_isMapHidden()
      @_showMap()
      @_loadMap()
    else
      @_hideMap()

  _isMapHidden: ->
    @mapEl.classList.contains('hide')

  _hideMap: ->
    @mapButtonToggleEl.classList.remove('active')
    @mapEl.classList.add('hide')

  _showMap: ->
    @mapButtonToggleEl.classList.add('active')
    @mapEl.classList.remove('hide')

  _loadMap: ->
    if (!window.BrowseMapsApplication)
      window.Groupon.Utils.loadAsyncJS(@domConfig.browseLazyLoadedMapsJavascript, @_onLazyLoadedMapsJavascript)
    else
      window.BrowseMapsApplication.loadMap()

  _fetchRelated: ->
    return unless @_shouldFetchRelated()

    @_removeRelatedCarousel()

    data =
      _csrf: @domConfig.csrfToken
      currentDeal: @lastClickedDeal.replace('deal:', '')

    relatedRetriever.getRelatedDealsCarousel(data).then(
      (response) =>
        @_renderRelatedDeals(response)
      (err) ->
        return
    )

  _removeRelatedCarousel: ->
    element = document.querySelector("figure[data-bhd*='thingsToDo_related_deals_browse']")
    element.parentNode.removeChild(element) if element?.parentNode
    locationRemembrance.clearRelatedDealIds()

  _shouldFetchRelated: ->
    return false unless @lastClickedDeal
    return false unless @clickedDealCard = document.querySelector("[data-bhc='#{@lastClickedDeal}']")
    return false if @clickedDealCard.classList?.contains('is-clo')
    relatedDealIds = locationRemembrance.getRelatedDealIds()
    return true unless relatedDealIds
    @lastClickedDeal not in relatedDealIds

  _toggleStickyHeader: ->
    headerOffset = document.querySelector(SELECTORS.FEATURED_REFINEMENT_UI)?.offsetTop + 135
    @_stickyHeader = ->
      if window.pageYOffset >= headerOffset
        document.querySelector(SELECTORS.PAGE_HEADER_TITLE)?.style.display = 'none'
        document.querySelector(STICKY.HEADER)?.classList.add('f-ref-ui-sticky')
        document.querySelector(STICKY.HEADER)?.classList.remove('row')
        document.querySelector(SELECTORS.FEATURED_FILTER_TOOLTIPS)?.classList.add('tooltip-offset')
        document.querySelector(STICKY.REFINEMENT)?.classList.add('header-column')
        document.querySelector(STICKY.REFINEMENT)?.classList.add('interior-tooltip')
      else
        headerOffset = document.querySelector(SELECTORS.FEATURED_REFINEMENT_UI)?.offsetTop + 135
        document.querySelector(STICKY.HEADER)?.classList.remove('f-ref-ui-sticky')
        document.querySelector(STICKY.HEADER)?.classList.add('row')
        document.querySelector(STICKY.REFINEMENT)?.classList.remove('header-column')
        document.querySelector(STICKY.REFINEMENT)?.classList.remove('interior-tooltip')
        document.querySelector('#pull-page-header').appendChild(document.querySelector(SELECTORS.PAGE_HEADER_TITLE))
        document.querySelector(SELECTORS.PAGE_HEADER_TITLE)?.style.display = ''

    window.addEventListener('scroll', @_stickyHeader)

  _onPopState: ->
    newParams = window.Groupon.Utils.unparam()
    # Some browsers (like Safari) will fire an initial popstate event
    # on page load, and we don't want to fire off searches etc
    # in that case (or anytime params haven't updated)
    return if shallowEqualObjects(newParams, @urlParams)

    @_updateParams(newParams)
    @_updateSearch()
    @_updatePageTracking()

  _renderRelatedDeals: (relatedModel) ->
    {relatedDealsHtml} = relatedModel
    return unless relatedDealsHtml

    { html, dealIds } = relatedDealsHtml
    return unless html and @clickedDealCard

    locationRemembrance.addRelatedDealIds(dealIds) if dealIds?.length

    cardsPerColumn = if @_removeLHNEnabled() then 3 else 2

    visibleNotFeaturedCards = @_getVisibleNotFeatured()
    clickedDealIndex = Array.prototype.indexOf.call(visibleNotFeaturedCards, @clickedDealCard)

    return unless clickedDealIndex > -1

    if isInTreatment('TTD_YMALForDealViews_Q119_2', 'Treatment')
      rowIndex = clickedDealIndex + (cardsPerColumn - clickedDealIndex % cardsPerColumn)
      insertAfterCard = visibleNotFeaturedCards.item(rowIndex - 1)

      if insertAfterCard
        insertAfterCard.setAttribute('data-pointer', clickedDealIndex % cardsPerColumn)
        insertAfterCard.insertAdjacentHTML('afterend', html)

      cardsHtml = document.querySelector(SELECTORS.CARDS)?.innerHTML
      if cardsHtml?.length
        sanitizedCardsHtml = cardsHtml.replace(/has-scroll-listener|has-viewportenter-listener|has-location-rememberance-listener/g, '')
        selectedDealBhc = this?.dataset?.bhc
        window.history?.replaceState?({sanitizedCardsHtml, selectedDealBhc}, null, window.location.href)
      @_addRelatedCardOnMouseDownListeners()

    if isFeatureEnabled('TTDshowYMALCarousel')
      @_initCardUI()

  _handlePageState: ->
    if document.querySelector(SELECTORS.NOCARDS)?.getAttribute('data-no-results') is 'true' and document.querySelectorAll(SELECTORS.NOCARDS_MESSAGE_GETAWAYS)?.length == 0
      if @urlParams.query
        @_performAllDealsSearch()
      else if @urlParams.maxPrice or @urlParams.minPrice
        @_performPriceSanitizerSearch()
      else
        @_performAllDealsSearch()

  _startSpinner: ->
    spinnerGroup.start 'search',
      el: SELECTORS.CARDS_WRAPPER
    @spinnerRunning = true

  _stopSpinner: ->
    GIG.Utils.truncateElements(SELECTORS.CARDS, { watch: false })
    return unless @spinnerRunning

    spinnerGroup.stop 'search'
    @spinnerRunning = false

  _renderModel: (pageModel) ->
    {cardsHtml, noCardsHtml, pageHeaderTitleHash} = pageModel

    @_updateTitles(pageHeaderTitleHash)

    if isEmpty(cardsHtml) and isEmpty(noCardsHtml)
      @_onSearchError()
    else if noCardsHtml
      @_updateNoCards noCardsHtml
    else if cardsHtml
      @_onCardsHtmlUpdateCards(pageModel)

    if @preloadedNextPageRetriever
      @preloadedNextPageNum = null
      @preloadedNextPageModelJSON = null
      window.addEventListener('scroll', @_onScroll)

  _removeShellCards: ->
    shellCards = document.querySelectorAll("#{SELECTORS.CARDS} .cui-shell-card")
    for card in shellCards
      card.remove()

  _onSearchSync: (res) ->
    @_renderModel(res)

  _onPreloadedNextPageModelSync: (res) ->
    @preloadedNextPageModelJSON = res

  _onLazyLoadingModelSync: (res) ->
    @lazyLoadingModelJSON = res
    {cardsHtml} = @lazyLoadingModelJSON

    @_removeShellCards()

    if cardsHtml
      @cardsView.append cardsHtml
      window.BrowseThingsToDoApplication?.fetchTargetedAudience() if isTTDLandingPage()
      @_initCardUI()

      allCards = document.querySelectorAll(SELECTORS.CARDS + ' .card-ui:not(.has-location-rememberance-listener)')
      allCards.forEach(addMouseDownListenerForCard())

      window.Groupon.DFPAds.load() if window.Groupon?.DFPAds?.load?

  _clearNoCardsMessage: ->
    document.querySelector(SELECTORS.NOCARDS)?.innerHTML = null

  _onCardsHtmlUpdateCards: (searchResults) ->
    @_updateCards searchResults
    window.BrowseThingsToDoApplication?.fetchTargetedAudience() if isTTDLandingPage()

  _updateTitles: (pageHeaderTitleHash) ->
    return unless pageHeaderTitleHash
    @pageHeaderView.render pageHeaderTitleHash
    document.title = pageHeaderTitleHash.pageTitle

  _clearSearchBar: ->
    document.querySelector('#ls-search')?.value = ''

  _getFilterOptions: ->
    container: SELECTORS.REFINEMENT_UI
    rightEndContainer: SELECTORS.FEATURED_RIGHT_END_REFINEMENT_UI
    featuredContainer: SELECTORS.FEATURED_REFINEMENT_UI
    showAllFiltersToggle: @domConfig.enabledFeatures?.showToggleAllFilters
    initialFilterHide: @domConfig.enabledFeatures?.showToggleAllFilters
    showLeftHandNav: !@domConfig.enabledFeatures?.showDesktopExposedFilters
    showMapButton: @shouldShowMapButton
    queryStoreCallBack: @_clearSearchBar

  _updateCards: (searchResults) ->
    {cardsHtml, refinementUIHash, paginationHash, rapiDebug, aiAdsHash, map} = searchResults

    @cardsView.render cardsHtml, aiAdsHash

    if @lazyLoadingRetriever
      allCards = document.querySelectorAll(SELECTORS.CARDS + ' .card-ui:not(.has-location-rememberance-listener)')
      allCards.forEach(addMouseDownListenerForCard())

    if document.querySelector(SELECTORS.NOCARDS)?.getAttribute('data-no-results') is 'true' and document.querySelectorAll(SELECTORS.NOCARDS_MESSAGE_GETAWAYS)?.length == 0
      @_showCardsAndNoCards()
    else
      @_showCards()

    @paginationView.render presentedHash: paginationHash
    if @shouldRefreshRefinements
      if not @desktopFilters?
        @_loadRefinementUi(refinementUIHash?.refinementUI?.widgets)
      else
        @desktopFilters?.updateRefinements(refinementUIHash?.refinementUI?.widgets)
    else
      @shouldRefreshRefinements = true

    @debugView.render rapiDebug

    @_initCardUI()
    # https://jira.groupondev.com/browse/ION-7882
    setTimeout(@_forceImageToLoad, 1000)

    @_updateMap(map) if map?
    @_updateMapButton(map?.show)
    @_stopSpinner()
    PaginationSeoLinks.set()

  _updateNoCards: (noCardsHtml) ->
    @noCardsView.render noCardsHtml
    document.querySelector(SELECTORS.NOCARDS)?.setAttribute('data-no-results', true)
    @_showNoCards()
    if not document.querySelector(SELECTORS.NOCARDS_MESSAGE_GETAWAYS)
      @_performPriceSanitizerSearch()
    else
      document.querySelector('.getaways_reset')?.addEventListener 'click', =>
        @_performGetawaysReset()
      @_stopSpinner()

  _performPriceSanitizerSearch: ->
    if @_sanitizePriceUrl() is false
      return @_performAllDealsSearch()
    @_updateSearch()
    @_updatePageTracking()

  _performGetawaysReset: ->
    @_sanitizeHotelAvailabilityUrl()
    @_updateSearch()
    @_updatePageTracking()

    resetOptions =
      tryDifferentDate: true

    @desktopFilters?.resetRefinement('calendar', resetOptions)

  _updateMap: (map) ->
    if !@_isMapHidden()
      if map?.show
        @_loadMap()
      else
        document.querySelector('#featured-map-box').dispatchEvent(new Event('click'))

  _updateMapButton: (visible) ->
    @shouldShowMapButton = visible
    mapFilterBox = document.querySelector('.pull-map-button') or document.querySelector('#featured-map-box')
    if mapFilterBox?
      if visible
        mapFilterBox.classList.remove('hide-refinement-box')
      else
        mapFilterBox.classList.add('hide-refinement-box')
      @_adjustFilterContainerWidth(visible)

  _canShowRelatedDeals: ->
    @domConfig.enabledFeatures?.showYMALCarousel ? false

  _removeLHNEnabled: ->
    @domConfig.enabledFeatures?.removeLeftHandNav ? false

  _scrollToTopOnRefine: ->
    window.scrollTo({top: 0})

  _sanitizePriceUrl: ->
    return false unless @xhrParams.minPrice or @xhrParams.maxPrice or @urlParams.minPrice or @urlParams.maxPrice

    predicate = (key) -> [ 'minPrice', 'maxPrice' ].indexOf(key) == -1

    @urlParams = Object.keys(@urlParams).filter(predicate).reduce ((obj, key) =>
      obj[key] = @urlParams[key]
      obj), {}

    @xhrParams = Object.keys(@xhrParams).filter(predicate).reduce ((obj, key) =>
      obj[key] = @xhrParams[key]
      obj), {}

    @_updateUrl()

  _sanitizeHotelAvailabilityUrl: ->
    return false unless @xhrParams.hotelAvailability or @urlParams.hotelAvailability

    predicate = (key) -> [ 'hotelAvailability' ].indexOf(key) == -1

    @urlParams = Object.keys(@urlParams).filter(predicate).reduce ((obj, key) =>
      obj[key] = @urlParams[key]
      obj), {}

    @xhrParams = Object.keys(@xhrParams).filter(predicate).reduce ((obj, key) =>
      obj[key] = @xhrParams[key]
      obj), {}

    @_updateUrl()

  _onSearchError: (err) ->
    return if err?.name is 'AbortError'
    document.querySelector(SELECTORS.CARDSERROR)?.innerHTML = errorViewHtml.render()
    @_showError()
    @_stopSpinner()
    @_sanitizePriceUrl()

  _showCardsAndNoCards: ->
    document.querySelector(SELECTORS.CARDS)?.style.display = ''
    document.querySelector(SELECTORS.NOCARDS)?.style.display = ''
    document.querySelector(SELECTORS.PAGINATION)?.style.display = ''
    document.querySelector(SELECTORS.CARDSERROR)?.style.display = 'none'

  _showCards: ->
    document.querySelector(SELECTORS.CARDS)?.style.display = ''
    document.querySelector(SELECTORS.PAGINATION)?.style.display = ''
    document.querySelector(SELECTORS.CARDSERROR)?.style.display = 'none'
    document.querySelector(SELECTORS.NOCARDS)?.style.display = 'none'

  _showNoCards: ->
    document.querySelector(SELECTORS.NOCARDS)?.style.display = ''
    document.querySelector(SELECTORS.CARDS)?.style.display = 'none'
    document.querySelector(SELECTORS.PAGINATION)?.style.display = 'none'
    document.querySelector(SELECTORS.CARDSERROR)?.style.display = 'none'

  _showError: ->
    document.querySelector(SELECTORS.CARDSERROR)?.style.display = ''
    document.querySelector(SELECTORS.CARDS)?.style.display = 'none'
    document.querySelector(SELECTORS.PAGINATION)?.style.display = 'none'
    document.querySelector(SELECTORS.NOCARDS)?.style.display = 'none'

  _shouldUpdate: (newUrlParams) ->
    currentParams = Object.assign({}, @urlParams)
    if currentParams.page then delete currentParams.page
    not shallowLooseEqualObjects(newUrlParams, currentParams)

  _onUpdate: (selectedRefinements, isRefinementUpdated, isReset = false) ->
    newUrlParams = appUrl.updateParams(selectedRefinements, isRefinementUpdated)

    omitUndefined newUrlParams

    if @_shouldUpdate(newUrlParams)
      @_updateParams(newUrlParams)
      @_updateUrl({ pushState: true })
      @_scrollToTopOnRefine()
      @_updateSearch()
      @_updatePageTracking()
      window.BrowseThingsToDoApplication?.updatePlannerWidget()
      locationRemembrance.addDealClickHandler()

  _isCachedPageMatchingNextRequest: ->
    @preloadedNextPageNum == @xhrParams.page and @preloadedNextPageModelJSON?

  _renderNextPage: ->
    if not @_isCachedPageMatchingNextRequest()
      return @_updateSearch()

    @_renderModel(@preloadedNextPageModelJSON)

  _setNoResultsDataToFalse: ->
    document.querySelector(SELECTORS.NOCARDS)?.setAttribute('data-no-results', false)

  _getUrlParams: (href) ->
    window.Groupon.Utils.unparam(href.split("?")[1] ? '')

  _getVisibleNotFeatured: ->
    selector = ".cui-c-udc:not(#{SELECTORS.FEATURED_CARDS}):not(#{SELECTORS.FALLBACK_FEATURED_CARDS}):not(#{SELECTORS.EMBEDDED_CARDS})"
    document.querySelector(SELECTORS.CARDS)?.querySelectorAll(selector)

  _scrollToTop: ->
    window.scrollTo({top: 0})

  _onPaginationClick: ->
    (event) =>
      @_setNoResultsDataToFalse()
      newUrlParams = @_getUrlParams(event.detail?.href)
      @_updateParams(newUrlParams)
      @_updateUrl({ pushState: true })
      @_scrollToTop()
      @_renderNextPage()
      @shouldRefreshRefinements = false
      @_loadAds()

  _performAllDealsSearch: ->
    @_removeParams()
    @_updateParams()
    @_updateSearch()
    @_updatePageTracking()

  _removeParams: ->
    @defaults.urlParams = {}
    @defaults.xhrParams = omitUndefined
      _csrf: @domConfig.csrfToken
      division: @domConfig.division?.id
    @_setParams()
    @_updateUrl()

  _updatePageTracking: ->
    window.OptimizeSuite.treatAsNewPage(window.location.href)

  _updateParams: (newUrlParams = {}) ->
    return if shallowEqualObjects(newUrlParams, @urlParams)
    @_setParams(newUrlParams)

    tmpUrlParams = {}
    Object.keys(@urlParams).filter((key) => @urlParams[key]?).forEach (key) =>
      tmpUrlParams[key] = @urlParams[key]

    @urlParams = tmpUrlParams

  _updateSearch: ->
    @_startSpinner()
    @searchRetriever.get(@xhrParams).then(
      (res) => @_onSearchSync res
      (err) => @_onSearchError err
    )

  _updateUrl: (opts = {}) ->
    paramString = toString(@urlParams)
    updatedUrl = window.location.pathname

    if paramString.length
      updatedUrl += "?#{paramString}"

    urlUpdate.update(updatedUrl, opts)

  _forceImageToLoad: ->
    images = document.querySelectorAll(SELECTORS.CARD_IMAGES)
    return unless images.length
    return unless firstImage = images[0]
    return unless firstImage.getAttribute('src').lastIndexOf('data:', 0) is 0
    context._initCardUI()